<cap-content-header>
  <cap-title>
    {{ "publikation.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<form (ngSubmit)="onSubmit()" [meta]="publikation" #form="ngForm">
  <cap-form-row>
    <div class="col-md-6">
      <h3 class="title-divider-suche pt-2">{{ "publikationAmtHeading" | translate }}</h3>
      <ng-form>
        <fieldset>
          <cap-form-row>
            <cap-form-control column-classes="col-md-4,col-md-8" invalidKey="EingabeGrundbuchamtErforderlich" labelKey="Grundbuchamt">
              <cap-gb-amt
                (ngModelChange)="publikation && (publikation.grundbuchamtId = $event)"
                [hasfocus]="true"
                [ngModel]="publikation && publikation.grundbuchamtId"
                [nurGueltige]="true"
                [searchMode]="gbAmtSearchMode"
                class="typeahead-holder"
                name="grundbuchamtId">
              </cap-gb-amt>
              <button (click)="emptyGbAmtSearch()" class="btn btn-white" tabindex="-1" type="button">
                <span class="fas fa-times"></span>
              </button>
            </cap-form-control>
          </cap-form-row>
        </fieldset>
      </ng-form>
    </div>

    <div class="col-md-6">
      <h3 class="title-divider-suche col-md-12 pt-2">{{ "publikationDateHeading" | translate }}</h3>
      <cap-form-row column-classes="col-md-1,col-md-1">
        <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumVon">
          <cap-datepicker
            (ngModelChange)="publikation && (publikation.datumVon = $event)"
            [ngModel]="publikation && publikation.datumVon"
            name="datumVon"></cap-datepicker>
        </cap-form-control>
        <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumBis">
          <cap-datepicker
            (ngModelChange)="publikation && (publikation.datumBis = $event)"
            [ngModel]="publikation && publikation.datumBis"
            name="datumBis"></cap-datepicker>
        </cap-form-control>
      </cap-form-row>
    </div>
  </cap-form-row>
  <cap-form-row>
    <cap-grundstueck-nummer
      (ngModelChange)="publikation && (publikation.grundstueckNummer = $event)"
      [ngModel]="publikation && publikation.grundstueckNummer"
      [searchMode]="gbGemeindeSearchMode"
      class="col-md-12 mt-2"
      heading="GrundstueckNummer"
      name="grundstueckNummer"></cap-grundstueck-nummer>
  </cap-form-row>
  <cap-form-row>
    <cap-form-control column-classes="col-md-1,col-md-3" invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
      <input
        (ngModelChange)="publikation && publikation.egrid && (publikation.egrid.value = $event)"
        [ngModel]="publikation && publikation.egrid && publikation.egrid.value"
        name="egrid.value"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
